<template>
    <div class="row filter-wrap">
        <div class="col">
            <filter-block @updateFinance="update()" details="true"></filter-block>
            <finance-details></finance-details>
        </div>
    </div>
</template>

<script>
    import FilterBlock from "../FinanceFilter/FilterBlock";
    import FinanceDetails from "../FinanceFilter/FinanceDetails";
    export default {
        name: "FinanceFilter",
        components: {FinanceDetails, FilterBlock},
        methods: {
            update: function() {
                this.$scrollTo('.filter-wrap');
            }
        }
    }
</script>

<style scoped lang="stylus">
    .filter-wrap
        margin-bottom 20px
</style>